/**
 * Offline banner (Phase 3, §5.6). Sticky amber strip mounted in `AppShell` above
 * the `<Outlet>`. While offline it announces that only the last in-memory data
 * is shown — pages keep rendering their RAM query cache behind it (nothing stale
 * is served from disk; the cache is empty after a reload). It renders nothing
 * while online.
 */
import { WifiOff } from 'lucide-react';
import { useOnlineStatus } from '../context/OnlineStatusContext.tsx';

export function OfflineBanner() {
  const { online } = useOnlineStatus();
  if (online) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-30 flex items-center justify-center gap-2 border-b border-amber-200/60 bg-amber-50/90 px-4 py-2 text-sm font-medium text-amber-800 backdrop-blur-sm dark:border-amber-900/50 dark:bg-amber-950/90 dark:text-amber-200"
    >
      <WifiOff className="h-4 w-4 shrink-0" aria-hidden />
      <span>Keine Verbindung — zuletzt geladene Daten</span>
    </div>
  );
}
